export const getShouldAutoPlayVideo = (url: string): boolean => {
  try {
    return new URL(url).searchParams.get('autoplay') === '1'
  } catch {
    return false
  }
}
